export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-[1280px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-semibold mb-5 whitespace-nowrap">
              <i className="ri-fire-line text-sm"></i>
              实时更新 · 全网最快吃瓜平台
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-black text-foreground-950 leading-tight mb-4">
              黑料网站
              <span className="block text-primary-600 mt-1">娱乐圈第一手爆料平台</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading font-semibold mb-6">
              吃瓜第一线，爆料不打烊
            </p>

            <p className="text-sm md:text-base text-foreground-500 leading-relaxed max-w-[600px] mx-auto lg:mx-0 mb-8">
              黑料网站是国内领先的娱乐八卦聚合平台，覆盖黑料网在线观看、吃瓜黑料在线、51黑料在线观看等热门内容频道。
              我们全天候追踪娱乐圈最新动态，从明星恋情实锤到网红翻车现场，从选秀黑幕到综艺内幕，
              以最快速度为你呈现第一手吃瓜爆料。平台汇集海量黑料视频与独家深度报道，
              是千万吃瓜群众的每日必刷站点。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">12,680+</p>
                <p className="text-xs text-foreground-500 mt-1">累计爆料</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-accent-600">每日更新</p>
                <p className="text-xs text-foreground-500 mt-1">更新频率</p>
              </div>
              <div className="text-center">
                <p className="text-2xl md:text-3xl font-heading font-bold text-primary-600">8,350万+</p>
                <p className="text-xs text-foreground-500 mt-1">月访问量</p>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#topics"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-lg text-base transition-colors whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-flashlight-line text-lg"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-8 py-3.5 border-2 border-foreground-300 hover:border-primary-500 hover:text-primary-600 text-foreground-700 font-semibold rounded-lg text-base transition-all whitespace-nowrap cursor-pointer no-underline"
              >
                <i className="ri-smartphone-line text-lg"></i>
                下载APP
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stylized%20abstract%20composition%20with%20bold%20red%20crimson%20and%20deep%20charcoal%20tones%2C%20overlapping%20geometric%20shapes%20reminiscent%20of%20breaking%20news%20graphics%2C%20dynamic%20diagonal%20lines%2C%20editorial%20magazine%20aesthetic%2C%20modern%20media%20art%20style%2C%20clean%20minimal%20background%20with%20dramatic%20focal%20elements%2C%20high%20contrast%2C%20professional%20design&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                alt="黑料网站 - 娱乐圈第一手爆料平台主视觉"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-900/20 to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-2">
                <span className="px-3 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-lg text-xs font-semibold text-primary-700 whitespace-nowrap">
                  <i className="ri-live-line mr-1"></i>实时追踪中
                </span>
                <span className="px-3 py-1.5 bg-background-50/90 backdrop-blur-sm rounded-lg text-xs font-semibold text-accent-700 whitespace-nowrap">
                  今日更新 37 条
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}